export const PUBLISH_IN_PROGRESS = 'PUBLISH_IN_PROGRESS';
export const PUBLISH_SUCCESS = 'PUBLISH_SUCCESS';
export const PUBLISH_ERROR = 'PUBLISH_ERROR';
export const DOWNLOAD_IN_PROGRESS = 'DOWNLOAD_IN_PROGRESS';
export const DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS';
export const DOWNLOAD_ERROR = 'DOWNLOAD_ERROR';
export const RESET_STATUS = 'RESET_STATUS';
